/**
 * Analytics Formatting Utilities
 */

export const formatValue = (value, format) => {
  if (value === null || value === undefined) return 'N/A';
  
  switch (format) {
    case 'currency':
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    case 'percentage':
      return `${Number(value).toFixed(1)}%`;
    case 'number':
      return Number(value).toLocaleString();
    case 'decimal':
      return Number(value).toFixed(1);
    default:
      return value;
  }
};

export const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric'
  });
};

export const formatDateLong = (dateStr) => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', { 
    weekday: 'long',
    month: 'long', 
    day: 'numeric',
    year: 'numeric'
  });
};

export const formatCapturedAt = (capturedAt, timestamp) => {
  try {
    // Handle Firestore Timestamp object
    if (capturedAt?.toDate) {
      return capturedAt.toDate().toLocaleString();
    } 
    // Handle Firestore timestamp with seconds/nanoseconds
    else if (capturedAt?.seconds) {
      const milliseconds = capturedAt.seconds * 1000 + (capturedAt.nanoseconds || 0) / 1000000;
      return new Date(milliseconds).toLocaleString();
    }
    // Handle plain timestamp string/number
    else if (capturedAt) {
      const date = new Date(capturedAt);
      if (!isNaN(date.getTime())) {
        return date.toLocaleString();
      }
    }
    
    // Fallback to timestamp field
    if (timestamp?.toDate) {
      return timestamp.toDate().toLocaleString();
    } else if (timestamp?.seconds) {
      const milliseconds = timestamp.seconds * 1000 + (timestamp.nanoseconds || 0) / 1000000;
      return new Date(milliseconds).toLocaleString();
    }
    
    return `Unknown time`;
  } catch (e) {
    console.error('Error parsing capturedAt:', e, capturedAt);
    return 'Parse error';
  }
};

